module.exports = __webpack_public_path__ + "media/1.af8a9ab1.mp3";